module.exports = __webpack_public_path__ + "img/ig.e6ea5951.svg";